import React, { useContext, useEffect, useState } from "react";
import { Button, Card, DatePicker, Form, Select, Space, Table, Tag, TimePicker, Tooltip, } from "antd";
import useApi from "../../hooks/useApi";
import { AppStateContext } from "../../context/AppContext";
import { ShowToast, Severty } from "../../helper/toast";
import AcceptedImg from "../../assets/images/accepted-new-image.png";
import CompletedImg from "../../assets/images/compleated-new-image.png";
import CancelImg from "../../assets/images/rejected-new-image.png";
import { Modal } from "antd";
import { ListClass, UpdateBooking, classReservations, getKyus, grantKyu, } from "../../constants/API/API";
import moment from "moment";
import callApi from "../../constants/API/CallApi";
import { useParams } from "react-router";
import apiPath from "../../constants/apiPath";
import useRequest from "../../hooks/useRequest";


const BOOKING_STATUS = [
  { value: "pending", label: "Pending" },
  { value: "cancelled", label: "Cancelled" },
  { value: "completed", label: "Completed" },
  { value: "rescheduled", label: "Rescheduled" },
  { value: "accepted", label: "Accepted" },
  { value: "missed", label: "Missed" },
];

const { Option } = Select;

const Booking = () => {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Class Reservations");

  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [filterDate, setFilterDate] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [rescheduleRecord, setRescheduleRecord] = useState(null);
  const [classList, setClassList] = useState([]);
  const [grantModalVisible, setGrantModalVisible] = useState(false);
  const [selected, setSelected] = useState(null);
  const { classId, slotId, slot } = useParams();
  const [selectedKyu, setSelectedKyu] = useState(null);
  const [kyuOptions, setKyuOptions] = useState([]);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [cancelRecord, setCancelRecord] = useState(null);
  const [cancelAllRecurring, setCancelAllRecurring] = useState(false);

  const { request } = useRequest();

  const handleStatusChange = (newStatus, record) => {
    setLoading(true);
    const payload = {
      status: newStatus,
      date: moment(selectedDate).format("YYYY-MM-DD HH:mm:ss.SSSSSS"),
      slot: selectedTime,
    };
    callApi({
      method: "PUT",
      callback: () => UpdateBooking(payload, record._id),
      onSuccess: () => {
        setLoading(false);
        setRefresh((x) => !x);
        ShowToast(`Booking marked as ${newStatus}`, Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleStatusChangeWithConfirm = (status, record) => {
    Modal.confirm({
      title: `${status} Booking!`,
      content: `Are you sure you want to mark this booking's status as "${status}"?`,
      okText: "Yes",
      cancelText: "No",
      okButtonProps: { type: "primary", danger: status === "  " },
      onOk: () => handleStatusChange(status, record),
    });
  };

  const handleRescheduleClick = (record) => {
    setRescheduleRecord(record);
    setIsRescheduleModalOpen(true);
  };

  const handleGrantKyu = () => {
    if (!selectedKyu) {
      return ShowToast("Please select next kyu to grant!", "error");
    }
    setLoading(true);
    callApi({
      callback: grantKyu,
      payload: { progressId: selected?.progress?._id, nextKyuId: selectedKyu },
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        setRefresh((x) => !x);
        setGrantModalVisible(false);
        setSelected(null);
        setSelectedKyu(null);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useApi({
    callback: getKyus,
    payload: {
      value: selected?.student?.kyu?.requiredClasses,
      beltId: selected?.student?.beltId,
    },
    dependencies: [selected, refresh],
    shouldCallApi: true,
    onSuccess: (data) => {
      console.log(data);
      setLoading(false);
      setKyuOptions(data?.data || []);
    },
    onError: (err) => {
      console.log(err);
      setLoading(false);
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [classRes] = await Promise.all([ListClass()]);

        setClassList(classRes?.data?.list || []);
      } catch (error) {
        setClassList([]);
      }
    };
    fetchData();
  }, []);

  useApi({
    callback: classReservations,
    payload: { slotId, slot, classId, date: filterDate },
    dependencies: [refresh, filterDate],
    shouldCallApi: true,
    onSuccess: (data) => {
      const sortedDocs = [...(data?.docs || [])].sort((a, b) => {
        const aVal = a?.progress?.extraClasses ?? 0;
        const bVal = b?.progress?.extraClasses ?? 0;

        if (aVal < 0 && bVal < 0) return aVal - bVal;
        if (aVal < 0) return -1;
        if (bVal < 0) return 1;
        return 0;
      });
      setData(sortedDocs);
      setTotalDocs(data?.totalDocs);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });



  const handleCancelBooking = async () => {
    if (!cancelRecord) return;

    const userId = cancelRecord?.studentId || cancelRecord?.userId;
    if (!userId) return ShowToast("Student info missing!", Severty.ERROR);

    const payloadUrl = `${apiPath.cancelBooking}/${cancelRecord._id}?userId=${userId}&cancelAll=${cancelAllRecurring}`;

    setLoading(true);

    request({
      url: payloadUrl,
      method: "POST",
      onSuccess: (res) => {
        const msg = res?.message || "Booking cancelled successfully!";
        ShowToast(msg, Severty.SUCCESS);
        setRefresh(x => !x);
        setIsCancelModalOpen(false);
        setCancelAllRecurring(false);
        setCancelRecord(null);
        setLoading(false);
      },
      onError: (err) => {
        const errMsg = err?.message || "Something went wrong!";
        ShowToast(errMsg, Severty.ERROR);
        setLoading(false);
      },
    });
  };


  const columns = [
    // {
    //   title: "Booking ID",
    //   dataIndex: "bookingId",
    //   key: "bookingId",
    //   render: (_, { bookingId }) => bookingId || "-",
    // },
    {
      title: "Student",
      dataIndex: "user",
      key: "user",
      render: (text, record) => record?.student?.name || record?.user?.name,
    },
    {
      title: "Parent",
      dataIndex: "user",
      key: "user",
      render: (text, record) =>
        !record?.student?.name ? "Self" : record?.user?.name,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text, record) =>
        record?.date ? moment(record?.date).format("ll") : "-",
    },
    {
      title: "Current Kyu",
      dataIndex: "kyu",
      key: "kyu",
      render: (_, record) => {
        return (
          <Tag>
            {record?.student?.kyu?.name}
          </Tag>
        );
      },
    },

    {
      title: "Kyu Attendance",
      key: "kyuAttendance",
      sorter: (a, b) => {
        const aExtra = a?.progress?.extraClasses;
        const bExtra = b?.progress?.extraClasses;

        const aVal =
          aExtra === null || aExtra === undefined ? 0 : aExtra;
        const bVal =
          bExtra === null || bExtra === undefined ? 0 : bExtra;

        if (aVal < 0 && bVal < 0) return aVal - bVal;

        if (aVal < 0) return -1;
        if (bVal < 0) return 1;

        return 0;
      },
      defaultSortOrder: "ascend",
      render: (_, record) => {
        const attendedClasses = record?.progress?.attendedClasses ?? 0;
        const extraClasses = record?.progress?.extraClasses;

        if (extraClasses === null || extraClasses === undefined || extraClasses === 0) {
          return <span>{attendedClasses}</span>;
        }

        if (extraClasses < 0) {
          return (
            <span style={{ color: "red", fontWeight: 600 }}>
              {extraClasses}
            </span>
          );
        }

        return (
          <span style={{ color: "red", fontWeight: 600 }}>
            +{extraClasses}
          </span>
        );
      },
    },

    {
      title: "Kyu Eligibility",
      dataIndex: "kyuEligibility",
      key: "kyuEligibility",
      render: (_, record) => {
        const eligible = record?.progress?.eligible;
        return (
          <Tag color={eligible ? "green" : "red"}>
            {eligible ? "Eligible" : "Not Eligible"}
          </Tag>
        );
      },
    },
    {
      title: "Graduation Eligibility",
      dataIndex: "graduationEligibility",
      key: "graduationEligibility",
      render: (_, record) => {
        const eligible = record?.student?.kyu?.triggersGraduationEligibility;
        return (
          <Tag color={eligible ? "orange" : "blue"}>
            {eligible ? "Yes" : "No"}
          </Tag>
        );
      },
    },
    {
      title: "Recurring Classes",
      dataIndex: "isRecurring",
      key: "isRecurring",
      render: (_, record) => {
        const isRecurring = record?.recurring?.isRecurring === true;

        return (
          <Tag color={isRecurring ? "green" : "red"}>
            {isRecurring ? "Yes" : "No"}
          </Tag>
        );
      },
    },

    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      render: (_, record) => (
        <div className="main-newsmall-class-buttons">
          <Tooltip color="purple" title="Mark Attendance">
            <Button
              type="primary"
              onClick={() => handleStatusChangeWithConfirm("completed", record)}
            >
              <img src={CompletedImg} alt="Completed" />
            </Button>
          </Tooltip>

          <Tooltip color="purple" title={
            record?.student?.kyu?.triggersGraduationEligibility
              ? "Ready for Exam"
              : "Grant Kyu"}
          >
            <Button
              type="primary"
              disabled={!!record?.student?.kyu?.triggersGraduationEligibility}
              onClick={() => {
                setGrantModalVisible(true);
                setSelected(record);
              }}
            >
              <img src={AcceptedImg} alt="Grant Kyu" />
            </Button>
          </Tooltip>

          <Tooltip color="purple" title="Cancel Booking">
            <Button
              type="primary"
              danger
              onClick={() => {
                setCancelRecord(record);
                setIsCancelModalOpen(true);
              }}
            >
              <img src={CancelImg} alt="Cancel Booking" />
            </Button>
          </Tooltip>

        </div>
      ),
    },
  ];

  return (
    <>
      <div>
        <Button
          type="default"
          className="mb-2"
          style={{ color: "black" }}
          onClick={() => window.history.back()}
        >
          Back
        </Button>

        <Card
          title="Student List"
          className="mb-4 mt-4"
          extra={
            <>
              <DatePicker onChange={(val) => setFilterDate(val)} />
            </>
          }
        >
          <div className="table-responsive customPagination">
            <Table
              loading={loading}
              columns={columns}
              dataSource={data || []}
              pagination={true}
              rowKey="_id"
              bordered
              size="middle"
            />
          </div>

        </Card>
      </div>

      <Modal
        title="Reschedule Booking"
        open={isRescheduleModalOpen}
        className="tab_modal"
        onCancel={() => {
          setSelectedDate();
          setSelectedTime();
          setIsRescheduleModalOpen(false);
        }}
        onOk={() => {
          console.log("Rescheduling to:", selectedDate, selectedTime);
          // setIsRescheduleModalOpen(false);
          handleStatusChange("rescheduled", rescheduleRecord);
        }}
        okText="Reschedule"
      >
        <Form layout="vertical">
          <Form.Item label="Select New Date">
            <DatePicker
              value={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              style={{ width: "100%" }}
            // format="YYYY-MM-DD HH:mm:ss.SSSSSS"
            />
          </Form.Item>
          <Form.Item label="Select New Time">
            <TimePicker.RangePicker
              // value={selectedTime}
              placeholder={["StartTime", "EndTime"]}
              onChange={(time) => {
                let startTime = time[0]?.format("HH:mm");
                let endTime = time[1]?.format("HH:mm");
                let slot = `${startTime}-${endTime}`;
                setSelectedTime(slot);
              }}
              style={{ width: "100%" }}
              format="HH:mm"
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        open={grantModalVisible}
        title="Grant Next Kyu"
        onOk={handleGrantKyu}
        onCancel={() => {
          setGrantModalVisible(false);
          setSelectedKyu(null);
        }}
        okText="Grant"
      >
        <p>Select the next Kyu to assign:</p>
        <Select
          placeholder="Select Kyu"
          style={{ width: "100%" }}
          value={selectedKyu}
          onChange={(value) => setSelectedKyu(value)}
        >
          {kyuOptions.map((kyu, idx) => (
            <Option
              key={kyu?._id}
              value={kyu?._id}
            // disabled={() => {}}
            >
              {kyu.name}
            </Option>
          ))}
        </Select>
      </Modal>

      <Modal
        title="Cancel Booking"
        open={isCancelModalOpen}
        onCancel={() => {
          setIsCancelModalOpen(false);
          setCancelAllRecurring(false);
          setCancelRecord(null);
        }}
        onOk={handleCancelBooking}
        okText="Cancel Booking"
        className="tab_modal"
        okButtonProps={{ danger: true }}
      >
        <p>Are you sure you want to cancel this booking?</p>
        {cancelRecord?.recurring?.isRecurring && (
          <div style={{ marginTop: 10, display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              checked={cancelAllRecurring}
              onChange={(e) => setCancelAllRecurring(e.target.checked)}
              id="cancelAllRecurring"
            />
            <label htmlFor="cancelAllRecurring" style={{ marginLeft: 8 }}>
              Cancel all recurring bookings
            </label>
          </div>
        )}
      </Modal>


    </>
  );
};

export default Booking;
